import validate from "/home/raci_app/apps/default/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/raci_app/apps/default/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "sanctum:auth": () => import("/home/raci_app/apps/default/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.auth.js"),
  "sanctum:guest": () => import("/home/raci_app/apps/default/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.guest.js")
}